import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Box, Divider, Typography } from '@mui/material';

import { setPageTitle } from '../../../../redux/title/title.slice';

import dayjs from 'dayjs';

import { getFullBookTotal } from '../../../../redux/aum/aum.slice';

import AUMPerformanceChart from './aumPerformanceChart';
import ProviderAndAdvisorSummary from './providerAndAdvisorSummary';
import { getBusinessDays } from '../../../../redux/businessDay/businessDay.slice';
import BookAnalysisStats from './bookAnalysisStats';
import ProviderPerformanceChart from './providerPerformanceChart';

function BookAnalysis() {
  const dispatch = useDispatch();

  const { fullBookTotal, loadingFullBookTotal } = useSelector((state) => state.aum);

  const { businessDays, loadingBusinessDays } = useSelector((state) => state.businessDay);

  const [period, setPeriod] = useState('week');

  const [dateRange, setDateRange] = useState({
    from: null,
    to: null
  });

  useEffect(() => {
    if (!businessDays?.date) return;

    let fromDate;
    const toDate = dayjs(businessDays.date).format('YYYY-MM-DD');

    switch (period) {
      case 'week':
        fromDate = dayjs(businessDays.date).subtract(1, 'week').format('YYYY-MM-DD');
        break;

      case 'month':
        fromDate = dayjs(businessDays.date).subtract(1, 'month').format('YYYY-MM-DD');
        break;

      case 'quarter':
        fromDate = dayjs(businessDays.date).subtract(3, 'month').format('YYYY-MM-DD');
        break;

      case 'ytd':
        fromDate = dayjs(businessDays.date).startOf('year').format('YYYY-MM-DD');
        break;

      case 'custom':
        if (!dateRange?.from || !dateRange?.to) return;

        dispatch(
          getFullBookTotal({
            fromDate: dayjs(dateRange.from).format('YYYY-MM-DD'),
            toDate: dayjs(dateRange.to).format('YYYY-MM-DD')
          })
        );
        return;

      default:
        return;
    }

    dispatch(
      getFullBookTotal({
        fromDate,
        toDate
      })
    );
  }, [dispatch, businessDays?.date, period, dateRange]);

  useEffect(() => {
    if (businessDays?.date || loadingBusinessDays) return;

    dispatch(
      getBusinessDays({
        countryCode: 'ZA',
        lag: -2
      })
    );
  }, [dispatch, businessDays?.date, loadingBusinessDays]);

  useEffect(() => {
    dispatch(setPageTitle('Book Analysis'));
  }, [dispatch]);

  return (
    <>
      <Box sx={{ pb: 4, width: '100%' }}>
        <Typography
          variant="h6"
          color="accent"
          sx={{
            fontSize: '14px',
            fontWeight: 300,
            textTransform: 'uppercase'
          }}>
          OVERVIEW OF BOOK AUM, PLATFORMS AND ADVISORS
        </Typography>

        <Typography variant="headingText" sx={{ fontSize: 32 }}>
          Directors Dashboard
        </Typography>
      </Box>{' '}
      <Box
        sx={{
          display: 'flex',
          flexDirection: {
            xs: 'column-reverse',
            sm: 'column-reverse',
            md: 'column-reverse',
            lg: 'row'
          },
          gap: 3,
          alignItems: 'stretch',
          width: '100%',
          minHeight: {
            xs: 'auto',
            lg: 700
          }
        }}>
        {/* LEFT */}
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 3
          }}>
          <AUMPerformanceChart
            data={fullBookTotal}
            loading={loadingFullBookTotal}
            period={period}
            setPeriod={setPeriod}
            dateRange={dateRange}
            setDateRange={setDateRange}
          />

          <ProviderPerformanceChart data={fullBookTotal} />

          <BookAnalysisStats />
        </Box>

        <Divider
          orientation="vertical"
          flexItem
          sx={{
            display: {
              xs: 'none',
              sm: 'none',
              md: 'none',
              lg: 'block'
            }
          }}
        />

        {/* RIGHT */}
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column'
          }}>
          <ProviderAndAdvisorSummary />
        </Box>
      </Box>
    </>
  );
}

export default BookAnalysis;
